import React from 'react';
import ReactHtmlParser from 'react-html-parser';

import LazyImgixImage from '@components/LazyImgixImage';
import { IMGIX_URL } from '@src/env';
import { Reporter } from '@utils/backend-api/subscribe';

interface ProfileProps {
  reporter: Reporter;
}

const Profile = ({ reporter: { bio, name, title } }: ProfileProps) => {
  const imagePath = name.trim().replace(/ /g, '_');

  return (
    <div className="m-auto flex flex-col items-center justify-center gap-24 sm:flex-row sm:items-start">
      <LazyImgixImage
        className="h-full w-full"
        alt={`${name} headshot`}
        src={`${IMGIX_URL}/global/subscribe/${imagePath}.png`}
        wrapperClassName="rounded-full w-[100px] h-[100px] sm:h-[158px] sm:w-[158px] shrink-0"
      />
      <div className="flex flex-col items-center sm:items-start">
        <h4 className="m-0 font-suisse-works text-headline-xxs text-black">{name}</h4>
        <span className="mt-4 font-suisse-intl text-button-md text-grayscale-gray">{title}</span>
        <p className="mb-0 mt-16 max-w-[280px] text-left font-suisse-intl text-body-md text-black sm:max-w-[345px] md:max-w-[443px]">
          {ReactHtmlParser(bio)}
        </p>
      </div>
    </div>
  );
};

export default Profile;
